import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid2 as Grid,
  IconButton,
  Link,
  useTheme,
} from '@mui/material'
import { useState } from 'react'
import Colors from '../../../utils/colors.json'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import CloseIcon from '@mui/icons-material/Close'

const styles = (theme: any) => ({
  formCheckBox: {
    border: `1px solid ${Colors.BORDER_COLOR}`,
    borderRadius: '20px',
    paddingLeft: 2,
    paddingRight: 7,
  },
  textBold: {
    fontSize: '20px',
    fontWeight: 500,
    color: Colors.TEXT_COLOR_MAIN,
  },
  textLight: {
    fontSize: '16px',
    fontWeight: 400,
    color: Colors.TEXT_COLOR_QUATERNARY,
  },
  actionBtn: {
    borderRadius: '20px',
    textTransform: 'capitalize',
    minWidth: '180px',
    background: theme.customColors.button,
  },
  actionBtnBack: {
    borderRadius: '20px',
    textTransform: 'capitalize',
    minWidth: '180px',
    background: theme.customColors.btnBlack,
  },
  circleDot: {
    width: '5px',
    height: '5px',
    backgroundColor: Colors.CIRCLE_DOT_COLOR,
    borderRadius: '50%',
    display: 'inline-block',
  },
  title: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  readMore: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    borderRadius: '8px',
    backgroundColor: theme.palette.primary.main,
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  dialogCloseBtn: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
})

const Nominee = ({
  activeStep,
  setActiveStep,
}: {
  activeStep: number
  setActiveStep: (activeStep: number) => void
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const [selectedNominee, setSelectedNominee] = useState('')
  const [openDeclaration, setOpenDeclaration] = useState(false)
  const [checkedItems, setCheckedItems] = useState({
    terms: false,
    customerInfo: false,
    consent: false,
  })

  const members = [
    {
      name: 'Vinod',
      dob: '04/22/1994',
      age: 29,
      relation: 'Husband',
    },
    {
      name: 'Usha',
      dob: '04/10/2000',
      age: 24,
      relation: 'Wife',
    },
    {
      name: 'Geetha',
      dob: '04/10/1976',
      age: 48,
      relation: 'Mother',
    },
  ]

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    })
  }

  const handleOpenDeclaration = () => {
    setOpenDeclaration(true)
  }

  const handleCloseDeclaration = () => {
    setOpenDeclaration(false)
  }

  const handleMemberSelect = (e: any, name: string) => {
    console.log(e.target)
    if (e.target.checked) {
      setSelectedNominee(name)
    } else {
      setSelectedNominee('')
    }
  }

  return (
    <Box
      display={'flex'}
      justifyContent={'start'}
      alignItems={'center'}
      flexDirection={'column'}
      gap={3}
      width={'100%'}
      pl={2}
      pb={4}
    >
      <Dialog open={openDeclaration} onClose={handleCloseDeclaration}>
        <DialogTitle>Declaration</DialogTitle>
        <IconButton
          aria-label='close'
          onClick={handleCloseDeclaration}
          className={classes?.dialogCloseBtn}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div className={classes?.checkboxGroup}>
            <FormControlLabel
              control={
                <Checkbox
                  name='terms'
                  checked={checkedItems.terms}
                  onChange={handleChange}
                  color='primary'
                />
              }
              label='I hereby declare that all information provided above is true, and I accept all Terms & conditions'
            />
            <FormControlLabel
              control={
                <Checkbox
                  name='customerInfo'
                  checked={checkedItems.customerInfo}
                  onChange={handleChange}
                  color='primary'
                />
              }
              label='I confirm that I have read and noted all the details mentioned in the customer information sheet of Joel, Marina'
            />
            <FormControlLabel
              control={
                <Checkbox
                  name='consent'
                  checked={checkedItems.consent}
                  onChange={handleChange}
                  color='primary'
                />
              }
              label='I hereby consent to receive information from Central KYC Registry through SMS/email on the registered number/email address'
            />
          </div>
          <Link href='#' underline='always' className={classes?.readMore}>
            Read More
          </Link>
          <Button
            className={classes?.button}
            variant='contained'
            fullWidth
            disabled={!Object.values(checkedItems).every((item) => item)}
          >
            Continue
          </Button>
        </DialogContent>
      </Dialog>
      <Box width={'100%'}>
        <Box className={classes?.textBold}>
          Tell Us Who You Want To Make Nominee
        </Box>
        <Box className={classes?.textLight}>
          If Anything Happens To The Proposer, Nominee Is The One To Get the
          Benefits
        </Box>
      </Box>
      <Box
        display={'flex'}
        justifyContent={'start'}
        alignItems={'center'}
        width={'100%'}
      >
        <Grid container size={{ xs: 12 }} spacing={3}>
          {members?.map((member, index) => (
            <Grid size='auto' key={index}>
              <FormControlLabel
                className={classes?.formCheckBox}
                control={
                  <Checkbox
                    size='small'
                    checked={selectedNominee === member?.name}
                    onChange={(e) => handleMemberSelect(e, member?.name)}
                  />
                }
                label={
                  <Box
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'start'}
                    alignItems={'center'}
                    gap={1}
                  >
                    <span>{member?.name}</span>
                    {selectedNominee === member?.name && (
                      <>
                        <span>{member?.age} Years</span>
                        <span>({member?.dob})</span>
                        <span className={classes?.circleDot}></span>
                        <span>{member?.relation}</span>
                      </>
                    )}
                  </Box>
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <Grid
        size={{ xs: 12 }}
        textAlign={'center'}
        display={'flex'}
        justifyContent={'space-around'}
        mt={1}
      >
        <Button
          variant='contained'
          // color='primary'
          className={classes?.actionBtnBack}
          onClick={() => setActiveStep(activeStep - 1)}
        >
          Back
        </Button>
        <Button
          variant='contained'
          // color='primary'
          className={classes?.actionBtn}
          onClick={handleOpenDeclaration}
        >
          Submit
        </Button>
      </Grid>
    </Box>
  )
}

export default Nominee
